<template>
  <label class="container">{{ $t(`forms.${label}`) }}
    <input type="checkbox" v-bind:checked="value" @change="onChange" :id="id" />
    <span :for="id" class="checkmark"></span>
  </label>
</template>

<script>
export default {
  name: 'VvFormCheckboxInput',
  computed: {
    isValid() {
      if (this.valid === null) {
        return this.value !== ''
      } else {
        return this.valid
      }
    }
  },
  props: {
    id: {
      type: String
    },
    label: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    value: {
      type: Boolean,
      default: false
    },
    valid: {
      type: Boolean,
      default: null
    }
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  methods: {
    onChange() {
      this.$emit('input', !this.value)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/_variables.scss';

.container {
  display: block;
  position: relative;
  padding-left: 30px;
  padding-top: 3px;
  margin-bottom: 5px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  color: rgb(0, 0, 0);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 18px;
  width: 18px;
  border-radius: 4px;
  outline: solid 1px $primary;
  background-color: rgb(255, 255, 255);
}

.container input:checked ~ .checkmark {
  background-color: #004781;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.container input:checked ~ .checkmark:after {
  display: block;
}

.container .checkmark:after {
  left: 5px;
  top: 2px;
  width: 4px;
  height: 8px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

</style>
